import { render, staticRenderFns } from "./promo-payment.vue?vue&type=template&id=31b9c109"
import script from "./promo-payment.vue?vue&type=script&lang=js"
export * from "./promo-payment.vue?vue&type=script&lang=js"
import style0 from "./promo-payment.vue?vue&type=style&index=0&id=31b9c109&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports